import { defineMessages } from 'react-intl'

export default defineMessages({
  rightsReserved: {
    id: 'cp.components.footer.rightsReserved',
    defaultMessage: '. All rights reserved.',
  },
})
